import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export interface InvalidControlInfo {
  path: string;
  errors: Record<string, unknown> | null;
  control: AbstractControl;
}

declare module '@angular/forms' {
  interface AbstractControl {
    getInvalidControls(): InvalidControlInfo[];
    markAllAsTouchedAndGetInvalidControls(): InvalidControlInfo[];
  }
}

function collectInvalidControls(control: AbstractControl, currentPath = ''): InvalidControlInfo[] {
  if (control instanceof FormGroup) {
    return Object.entries(control.controls).flatMap(([key, childControl]) => {
      const childPath = currentPath ? `${currentPath}.${key}` : key;
      return collectInvalidControls(childControl, childPath);
    });
  }

  if (control instanceof FormArray) {
    return control.controls.flatMap((childControl, index) => {
      const childPath = `${currentPath}[${index}]`;
      return collectInvalidControls(childControl, childPath);
    });
  }

  return control.invalid
    ? [{
      path: currentPath || '(root)',
      errors: control.errors,
      control,
    }]
    : [];
}

function getInvalidControls(this: AbstractControl): InvalidControlInfo[] {
  return collectInvalidControls(this);
}

function markAllAsTouchedAndGetInvalidControls(this: AbstractControl): InvalidControlInfo[] {
  this.markAllAsTouched();
  this.updateValueAndValidity({ emitEvent: false });
  return collectInvalidControls(this);
}

if (!('getInvalidControls' in AbstractControl.prototype)) {
  Object.defineProperty(AbstractControl.prototype, 'getInvalidControls', {
    value: getInvalidControls,
    writable: true,
    configurable: true,
  });
}

if (!('markAllAsTouchedAndGetInvalidControls' in AbstractControl.prototype)) {
  Object.defineProperty(AbstractControl.prototype, 'markAllAsTouchedAndGetInvalidControls', {
    value: markAllAsTouchedAndGetInvalidControls,
    writable: true,
    configurable: true,
  });
}

export {};
